"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var BGImageBox_1 = require("../../atoms/BGImageBox/BGImageBox");
var Image = function (_a) {
    var width = _a.width, margin = _a.margin, imageUri = _a.imageUri, text = _a.text, isShaded = _a.isShaded;
    var imageStyles = {
        marginRight: margin + "px",
        minWidth: width + "px",
        height: "227px",
        listStyle: "none",
        boxShadow: "0 0 20px 3px rgb(0, 0, 0, " + (isShaded ? "0" : "0.25") + ")",
        // Shaded items shown only on wide screen
        "@media screen and (min-width: 1420px)": {
            opacity: isShaded ? "0.3" : "1",
            transition: "400ms ease-in-out",
        },
    };
    return (theme_ui_1.jsx(theme_ui_1.Box, { as: "li", sx: imageStyles },
        theme_ui_1.jsx(BGImageBox_1.BGImageBox, { gradient: "shadedCorner", img: imageUri },
            theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                    flexDirection: "column-reverse",
                    padding: theme_1.theme.space[3] + "px " + theme_1.theme.space[4] + "px",
                    lineHeight: theme_1.theme.lineHeights[2],
                    fontSize: theme_1.theme.fontSizes[3],
                    color: theme_1.theme.colors.white,
                    height: "100%",
                } }, text))));
};
exports.Image = Image;
